import { render, staticRenderFns } from "./ImportBookmark.vue?vue&type=template&id=06334d19&scoped=true"
import script from "./ImportBookmark.vue?vue&type=script&lang=js"
export * from "./ImportBookmark.vue?vue&type=script&lang=js"
import style0 from "./ImportBookmark.vue?vue&type=style&index=0&id=06334d19&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06334d19",
  null
  
)

export default component.exports